export const observereGroupedElementsToReadjust = (parentElement: HTMLElement, elementsToAdjust: HTMLElement[]) => {
  const callback = (mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList.contains('component') && mutation.target.classList.contains('mgnlEditorBar')) {
        if (mutation.target.hasAttribute('aria-hidden')) {
          elementsToAdjust.forEach((element) => {
            if (element.hasAttribute('bars-visible')) {
              element.removeAttribute('bars-visible');
            }
          });
        } else {
          elementsToAdjust.forEach((element) => {
            if (!element.hasAttribute('bars-visible')) {
              element.setAttribute('bars-visible', '');
            }
          });
        }
      }
    });
  };

  const observer = new MutationObserver(callback);

  const options = {
    childList: true,
    subtree: true,
    attributes: true,
  };

  observer.observe(parentElement, options);
};
